<template>
  <el-card>
    <el-form :inline="true" class="global-form2" ref="form" :model="formData" :rules="rules" label-width="120px"
      label-position="right">
      <el-form-item label="名称：" prop="facilityName">
        <el-input v-model="formData.facilityName" maxlength="20" show-word-limit placeholder="请输入名称"
          clearable></el-input>
      </el-form-item>
      <el-form-item label="类型：" prop="facilityTypeId">
        <el-select v-model="formData.facilityTypeId" placeholder="请选择类型" clearable filterable>
          <el-option v-for="(item, index) in typeList" :key="index" :label="item.facilityTypeName"
            :value="item.facilityTypeId"></el-option>
        </el-select>
      </el-form-item>
      <br>
      <el-form-item label="所属项目：" prop="projectId">
        <el-select v-model="formData.projectId" ref="select" placeholder="请选择所属项目" clearable filterable>
          <el-option v-for="(item, index) in projectList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="位置描述：" prop="address">
        <el-input type="text" placeholder="请输入位置描述信息" v-model="formData.address" maxlength="50" :rows="8"
          show-word-limit>
        </el-input>
      </el-form-item>
      <br>
      <el-form-item prop="fileList">
        <template slot="label">
          <span>上传图片<br>(最多一张)</span>
        </template>
        <div v-if="formData.fileList && formData.fileList.length" class="imgBlock">
          <el-image :src="formData.fileList[0].filePrefix + formData.fileList[0].fileUrl"
            :preview-src-list="[formData.fileList[0].filePrefix + formData.fileList[0].fileUrl]" fit="fill">
          </el-image>
          <span></span>
          <i class="el-icon-close" @click="imgRemove()"></i>
        </div>
        <UploadFile v-else @onSuccess="onSuccess" :slotShow='true'>
          <template>
            <i class="el-icon-plus"></i>
            <p>上传照片</p>
          </template>
        </UploadFile>
      </el-form-item>
      <br>
      <el-form-item label="定位" prop="resourcesLocationList">
        <map-location class="mapContent" :projectId="formData.projectId" :locationList="resourcesLocationList"
          :icon="require('@/assets/img/location.png')" :isChange="true" @locationChange="locationChange" :mapModel="true"></map-location>
      </el-form-item>
      <br>
      <el-form-item label=" ">
        <el-button type="primary" @click="onSubmit" :disabled="disabled" class="mr20">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import MapLocation from '@/components/mapLocation/Index.vue'
import UploadFile from '@/components/uploadFile/Index.vue'

export default {
  name: 'PointAddPage',
  components: { MapLocation, UploadFile },
  data () {
    return {
      typeList: [],
      disabled: false,

      formData: {
        facilityName: '',
        facilityTypeId: '',
        projectId: '',
        address: '',
        longitude: '',
        latitude: '',
        fileList: [],
        resourcesLocationList: []
      },

      rules: {
        facilityName: [
          { required: true, message: '请输入名称', trigger: ['blur', 'change'] }
        ],
        facilityTypeId: [
          { required: true, message: '请择类型', trigger: ['blur', 'change'] }
        ],
        projectId: [
          { required: true, message: '请选择所属项目', trigger: ['blur', 'change'] }
        ],
        resourcesLocationList: [
          { required: true, message: '请输入定位', trigger: ['blur', 'change'] }
        ]
      },

      resourcesLocationList: []

    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList || []
    },

    facilityId () {
      return this.$route.params.id || ''
    }

  },

  created () {
    this.getTypeList()
    if (this.facilityId) {
      this.loadData()
    }
  },
  methods: {

    locationChange (val) {
      this.formData.resourcesLocationList = val
    },

    getTypeList () {
      this.$axios.get(this.$apis.patrol.selectFacilityTypeByList).then(res => {
        this.typeList = res.list || []
      })
    },

    // 查看设备设施详情
    loadData () {
      return this.$axios.get(this.$apis.patrol.selectFacilityByFacilityId, {
        facilityId: this.facilityId
      }).then(res => {
        this.formData = res || {}
        setTimeout(() => {
          this.resourcesLocationList = this.formData.resourcesLocationList = [{ longitude: +this.formData.longitude, latitude: +this.formData.latitude }] || []
        }, 3000)
      })
    },

    // 文件上传成功返回
    onSuccess (file) {
      this.formData.fileList = [file]
    },

    imgRemove () {
      this.formData.fileList = []
    },

    onSubmit () {
      this.$refs.form.validate().then(() => {
        this.disabled = true
        const url = this.facilityId ? this.$apis.patrol.updateFacility : this.$apis.patrol.insertFacility
        const { longitude, latitude } = this.formData.resourcesLocationList[0]
        this.formData.longitude = longitude.toString()
        this.formData.latitude = latitude.toString()
        const info = JSON.parse(JSON.stringify(this.formData))
        delete info.resourcesLocationList
        this.$axios.post(url, info).then(() => {
          this.$router.push('/patrol/patrolPoint')
        }).finally(() => {
          this.disabled = false
        })
      })
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.imgBlock {
  position: relative;
  height: 104px;
  width: 104px;
  margin-right: 10px;
  border-radius: 2px;

  .el-image,
  img {
    width: 100%;
    height: 100%;
  }

  span {
    position: absolute;
    top: 0;
    right: 0;
    width: 0px;
    height: 0px;
    border-top: 34px solid $color-default;
    border-left: 34px solid transparent;
  }

  i {
    transition: all 0.3s;
    position: absolute;
    top: 3px;
    right: 3px;
    font-size: 15px;
    color: #ffffff;
    cursor: pointer;
  }

  i:hover {
    color: #ffffff98;
  }
}

::v-deep .el-upload--picture-card {
  width: 104px;
  height: 104px;
  line-height: 26px;
  padding: 25px 10px;
}

.mapContent {
  width: 800px;
}
</style>
